import React, { useEffect, useRef, useState } from 'react';
import {
  Typography,
} from '@mui/material';
import { updateBeneficiaryInfoAction,} from './../APIs/action';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAge, phoneNumberRegex } from '../AddNewBeneficiary';
import { UserFileDict } from '../../../../utils/settings';
import { fileReaderPromise } from '../../../../utils/utilFuntions';
import EditCard from './EditCard';
import { useNavigate } from 'react-router-dom';
export const PANRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i; 

const BeneficiaryDetailCard = ({ data, isNominee, scroll, key, NomineeIndex }) => {
  const { beneficiary_details, nominee_details } = data

  const [ nomineeData, setNomineeData] = useState(nominee_details);
  const [ beneficiaryData, setBeneficiaryData] = useState(beneficiary_details);

  const [ isNomineeEditing, setIsNomineeEditing ] = useState(false)
  const [ isBeneficiaryEditing, setIsBeneficiaryEditing ] = useState(false)
  const [ nomineeImage, setNomineeImage] = useState([]);
  const [ beneficaryImage, setBeneficaryImage] = useState(null);
  const [ errors, setErrors] = useState({});
  const nomineeSectionRef = useRef(null);
  const [ age, setAge] = useState();
  const ageFlag = age > 60 || age < 18;
  const navigate = useNavigate();

  const handleAgeCalculation = (inputDate) => {
    try {
      const age = getAge(inputDate);
      setAge(age);
    } catch (error) {
      console.error(error.message);
    }
  };
  
  useEffect(()=>{
    isNominee ? setIsNomineeEditing(true) : setIsBeneficiaryEditing(true)
  },[isNominee])

  useEffect(() => {
    handleAgeCalculation(beneficiaryData.date_of_birth);
  }, [beneficiaryData.date_of_birth]);

  const handleEditClick = async (e, nomineeData = null,  isNominee = false, index) => {
    if (isBeneficiaryEditing || isNomineeEditing) {
      e.preventDefault();
      const data = isNominee ? nomineeData : beneficiaryData  ;
      const newErrors = {};
      if (!data) {
        console.error('Data is null or undefined:', isNominee ? 'Nominee Data' : 'Beneficiary Data');
        return;
      }
      if (!data.first_name) newErrors.first_name = isNominee ? 'Please enter Nominee first name' : 'Please enter Beneficiary first name';
      if (!data.last_name) newErrors.last_name = isNominee ? 'Please enter Nominee last name' : 'Please enter Beneficiary last name';
      if (data.phone_no.length < 10) newErrors.phone_no = 'Enter a 10-digit mobile number';
      if (!phoneNumberRegex.test(data.phone_no)) newErrors.phone_no = 'Enter a valid mobile number';
      if (!data.email) newErrors.email = 'Enter a valid email id';
      if (ageFlag) newErrors.date_of_birth = 'Please enter a valid Date of Birth';

      setErrors(newErrors);
      if (Object.keys(newErrors).length > 0) {
        return;
      }

      const payload = {
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone_no: data.phone_no,
        date_of_birth: data.date_of_birth,
        document_upload_details: isNominee ? nomineeImage[index] : beneficaryImage,
      };

      if (isNominee) {
        payload.beneficiary_id = beneficiaryData.id;
      }

      await onUpdate(payload);
      if (isNominee) {
        setNomineeImage(prevImages => {
          const updatedImages = [...prevImages];
          updatedImages[index] = null; // Reset nominee image after update
          return updatedImages;
        });
      } else {
        setBeneficaryImage(null);
      }

    }
  };
  const handleDiscardClick = (setEntityState, setEntityDataState ) => {
    setEntityState(false);
    setEntityDataState(data);
  };
  const onUpdate = async (payload) => {
    const { error, message } = await updateBeneficiaryInfoAction(payload);
    if (!error) {
      navigate('/my-benefits/benefits-summary');
      toast.success('Beneficiary Details Updated Successfully');
    } else {
      toast.error(message);
    }
  };
  const handleChange = (event, isNominee , index) => {
    const { name, value } = event.target;
    if (isNominee) {
      setNomineeData(prevData => {
        const updatedNominees = [...prevData];
        updatedNominees[index] = {
          ...updatedNominees[index],
          [name]: value
        };
        return updatedNominees;
      });
    }
    else {
      setBeneficiaryData(prevData => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  const handleImageChange = async (event, isNominee, nomineeIndex=null) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      const base64String = await fileReaderPromise(file);
      const documentUploadDetails = {
        file_str_base64: base64String.replace('data:', '').replace(/^.+,/, ''),
        file_name: file.name,
        file_type: UserFileDict['PAN_CARD'],
      };
      if(isNominee && nomineeIndex !== null){
        setNomineeData(prevState => {
          const updatedNomineeDetails = [...prevState];
          updatedNomineeDetails[nomineeIndex] = {
            ...updatedNomineeDetails[nomineeIndex],
            pancard_image: documentUploadDetails.file_str_base64,
          };
          return updatedNomineeDetails;
        });
        setNomineeImage(prevImages => {
          const updatedImages = [...prevImages];
          updatedImages[nomineeIndex] = documentUploadDetails;
          return updatedImages;
        });
      }
      else{
        setBeneficiaryData(prevState => ({
          ...prevState,
          pancard_image: documentUploadDetails.file_str_base64,
        }));
        setBeneficaryImage(documentUploadDetails); 
      }
      
      
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };

  
  useEffect(() => {
    if (scroll === 'nominee-section' && nomineeSectionRef.current) {
      nomineeSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [scroll]);
  return (
    <>
      <Typography fontSize={'1rem'} fontWeight={'bold'}>Beneficiary Details</Typography>
      <EditCard
        EntityData={beneficiaryData}
        isEditing={isBeneficiaryEditing && !isNominee}
        errors={errors}
        age={age}
        handleChange={(e) => handleChange(e, false)}
        handleEditClick={handleEditClick}
        handleDiscardClick={handleDiscardClick}
        handleImageChange={(e) => handleImageChange(e)}
        newImage = {beneficaryImage}
      />
      {nomineeData.map((nominee, index) => (
        <>
          <Typography ref={nomineeSectionRef} id="nominee-section" fontSize={'1rem'} fontWeight={'bold'}>Nominee Details</Typography>
          <EditCard
            key={index}
            EntityData={nominee}
            isEditing={isNomineeEditing? NomineeIndex == index : false}
            isNominee={isNominee}
            errors={errors}
            age={age}
            handleChange={(e) => handleChange(e, true, index)}
            handleEditClick={(e) => handleEditClick(e, nominee, true, index)}
            handleDiscardClick={() => setIsNomineeEditing(false)}
            handleImageChange={(e) => handleImageChange(e, isNominee, index)}
            newImage={nomineeImage[index]}
          />
        </>
      ))}
    </>
  );
};

export default BeneficiaryDetailCard;
